var PopupView = ViewModel.extend({
    template: _.template($('#popuptemplate').html().trim())
});